import React, { useState } from 'react';
import { Shield, Key } from 'lucide-react';
import { useAuthStore } from '../../../stores/auth-store';
import { ChangePasswordModal } from './ChangePasswordModal';

export const ProfileSecurityCard: React.FC = () => {
  const { currentUser } = useAuthStore();
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);

  const lastLogin = currentUser?.lastLoginAt
    ? new Date(currentUser.lastLoginAt).toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : 'Jamais';

  const createdAt = currentUser?.createdAt
    ? new Date(currentUser.createdAt).toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    : 'Non renseignée';

  const updatedAt = currentUser?.updatedAt
    ? new Date(currentUser.updatedAt).toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : 'Non renseignée';

  return (
    <>
      <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200 tw-p-6">
        <div className="tw-flex tw-items-center tw-gap-2 tw-mb-6">
          <Shield className="tw-w-5 tw-h-5 tw-text-affinicar-primary" />
          <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900">
            Sécurité
          </h2>
        </div>

        {/* Dates */}
        <div className="tw-grid tw-grid-cols-3 tw-gap-4 tw-mb-6">
          <div>
            <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
              Date de création
            </label>
            <p className="tw-text-sm tw-text-gray-900">{createdAt}</p>
          </div>
          <div>
            <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
              Dernière modification
            </label>
            <p className="tw-text-sm tw-text-gray-900">{updatedAt}</p>
          </div>
          <div>
            <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
              Dernière connexion
            </label>
            <p className="tw-text-sm tw-text-gray-900">{lastLogin}</p>
          </div>
        </div>

        {/* Bouton changer mot de passe */}
        <div className="tw-flex tw-justify-start">
          <button
            onClick={() => setIsChangePasswordModalOpen(true)}
            className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2.5 tw-bg-affinicar-primary tw-text-white tw-text-sm tw-font-medium tw-rounded-md hover:tw-bg-affinicar-secondary tw-transition-colors"
          >
            <Key className="tw-w-4 tw-h-4" />
            Changer le mot de passe
          </button>
        </div>
      </div>

      <ChangePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={() => setIsChangePasswordModalOpen(false)}
      />
    </>
  );
};
